import { EXCLUDE_CLIENT_PROFILE_FIELDS_SYNC, INTEGRATIONS_CLIENT_PROFILE_FIELDS } from 'src/constants/clients';

// eslint-disable-next-line import/prefer-default-export
export const getIntegrationManagedFields = (integration) => INTEGRATIONS_CLIENT_PROFILE_FIELDS.filter((field) => {
  return !EXCLUDE_CLIENT_PROFILE_FIELDS_SYNC[integration]?.includes(field);
});
